import { all } from "redux-saga/effects";
import authSagas from "./authSagas";
import camDoSagas from "./camDoSagas";
import quanLyChoVaySagas from "./quanLyChoVaySagas";
import quanLyThuChiSagas from "./quanLyThuChiSagas";
import userSagas from "./userSagas";
import traGopSagas from "./traGopSagas";
import inChoVaySagas from "./inChoVaySagas";
import inLanDongLaiSagas from "./inLanDongLaiSagas";
import dongLaiSagas from "./dongLaiSagas";
import customerSagas from "./customerSagas";
import inThuChiSagas from "./inThuChiSagas";
import cauHinhSagas from "./cauHinhSagas";
import chiTietHopDongSagas from "./chiTietHopDongSagas";
import noPhaiThuSagas from "./noPhaiThuSagas";
import doiTinhTrangSagas from "./doiTinhTrangSagas";
import xoaHopDongSagas from "./xoaHopDongSagas";
import guiEmailSagas from "./guiEmailSagas";
import guiTinNhanSagas from "./guiTinNhanSagas";
import dongTienNhanhSagas from "./dongTienNhanhSagas";
import nhanVaySagas from "./nhanVaySagas";
import phiKhacSagas from "./phiKhacSagas";
import phiKhacHangKySagas from "./phiKhacHangKySagas";
import thuocTinhTaiSanSagas from "./thuocTinhTaiSanSagas";
import loaiTaiSanSagas from "./loaiTaiSanSagas";
import storeSagas from "./storeSagas";
import nguonKhachHangSagas from "./nguonKhachHangSagas";
import taiSanSagas from "./taiSanSagas";
import themMoiCamDoSagas from "./themMoiCamDoSagas";
import danhSachKhachHangSagas from "./danhSachKhachHangSagas";
import phanQuyenSagas from "./phanQuyenSagas";
import quanLyCuaHangSagas from "./quanLyCuaHangSagas";
import checkThongTinKhSagas from "./checkThongTinKhSagas";
import kiemTraNoXauSagas from "./kiemTraNoXauSagas";
import danhSachCuaHangSagas from "./danhSachCuaHangSagas";
import tongQuatCuaHangSagas from "./tongQuatCuaHangSagas";
import chiTietCuaHangSagas from "./chiTietCuaHangSagas";
import danhSachTaiSanSagas from "./danhSachTaiSanSagas";
import danhSachKhoSagas from "./danhSachKhoSagas";
import congNoThanhLySagas from "./congNoThanhLySagas";
import danhSachThanhLySagas from "./danhSachThanhLySagas";
import danhSachKiemKhoSagas from "./danhSachKiemKhoSagas";
import kiemKhoSagas from "./kiemKhoSagas";
import danhSachNhanVienSagas from "./danhSachNhanVienSagas";
import quanLyCongViecSagas from "./quanLyCongViecSagas";
import thuChiHopDongSagas from "./thuChiHopDongSagas";

import tinChapSagas from "./tinChapSagas";
import themMoiTinChapSagas from "./themMoiTinChapSagas";
import menuSagas from "./menuSagas";
import giaHanNoPhaiThuSagas from "./giaHanNoPhaiThuSagas";
import ghiChuChoVaySagas from "./ghiChuChoVaySagas";
import thongBaoSagas from "./thongBaoSagas";
import themMoiTraGopSagas from "./themMoiTraGopSagas";
import addOrEditStoreSagas from "./addOrEditStoreSagas";
import deleteStoreSagas from "./deleteStoreSagas";
import thuChiNgoaiLeSagas from "./thuChiNgoaiLeSagas";
import thongKeThuSagas from "./thongKeThuSagas";
import daoHoSagas from "./daoHoSagas";
import themMoiKhachHangSagas from "./themMoiKhachHangSagas";
import cuaHangDoiTacSagas from "./cuaHangDoiTacSagas";

import duNoChoVaySagas from "./duNoChoVaySagas";
import duNoNhanVaySagas from "./duNoNhanVaySagas";
import duNoGiaoNhanVienSagas from "./duNoGiaoNhanVienSagas";

import danhSachHopDongDeleteSagas from "./danhSachHopDongDeleteSagas";
import danhSachThuDeleteSagas from "./danhSachThuDeleteSagas";
import danhSachChiDeleteSagas from "./danhSachChiDeleteSagas";

import danhSachHopDongChoDuyetSagas from "./danhSachHopDongChoDuyetSagas";

import inNhanVaySagas from "./inNhanVaySagas";

import quanLyThuChiHopDongSagas from "./quanLyThuChiHopDongSagas";

import quanLyThuChiNgoaiLeSagas from "./quanLyThuChiNgoaiLeSagas";
import nguonVonSagas from "./nguonVonSagas";

import banHangTraGopSagas from "./banHangTraGopSagas";
import themMoiBanHangTraGopSagas from "./themMoiBanHangTraGopSagas";
import CauHinhGoiTraGopSagas from "./QuanTriHeThong/CauHinhGoiTraGop/CauHinhGoiTraGopSagas";
import ticketSaga from "./TicketSaga";
export default function* rootSaga() {
  yield all([
    authSagas(),
    camDoSagas(),
    quanLyChoVaySagas(),
    quanLyThuChiSagas(),
    userSagas(),
    traGopSagas(),
    inChoVaySagas(),
    inLanDongLaiSagas(),
    dongLaiSagas(),
    customerSagas(),
    inThuChiSagas(),
    cauHinhSagas(),
    chiTietHopDongSagas(),
    noPhaiThuSagas(),
    doiTinhTrangSagas(),
    xoaHopDongSagas(),
    guiEmailSagas(),
    guiTinNhanSagas(),
    dongTienNhanhSagas(),
    nhanVaySagas(),
    phiKhacSagas(),
    phiKhacHangKySagas(),
    thuocTinhTaiSanSagas(),
    loaiTaiSanSagas(),
    storeSagas(),
    nguonKhachHangSagas(),
    taiSanSagas(),
    themMoiCamDoSagas(),
    danhSachKhachHangSagas(),
    phanQuyenSagas(),
    quanLyCuaHangSagas(),
    checkThongTinKhSagas(),
    tinChapSagas(),
    themMoiTinChapSagas(),
    kiemTraNoXauSagas(),
    menuSagas(),
    danhSachCuaHangSagas(),
    tongQuatCuaHangSagas(),
    chiTietCuaHangSagas(),
    danhSachTaiSanSagas(),
    giaHanNoPhaiThuSagas(),
    ghiChuChoVaySagas(),
    danhSachKhoSagas(),
    congNoThanhLySagas(),
    danhSachThanhLySagas(),
    danhSachKiemKhoSagas(),
    kiemKhoSagas(),
    danhSachNhanVienSagas(),
    quanLyCongViecSagas(),
    thongBaoSagas(),
    thuChiHopDongSagas(),
    themMoiTraGopSagas(),
    thuChiNgoaiLeSagas(),
    addOrEditStoreSagas(),
    deleteStoreSagas(),
    thongKeThuSagas(),
    daoHoSagas(),
    themMoiKhachHangSagas(),
    cuaHangDoiTacSagas(),
    duNoChoVaySagas(),
    duNoNhanVaySagas(),
    duNoGiaoNhanVienSagas(),
    danhSachHopDongDeleteSagas(),
    danhSachThuDeleteSagas(),
    danhSachChiDeleteSagas(),
    danhSachHopDongChoDuyetSagas(),
    inNhanVaySagas(),
    quanLyThuChiHopDongSagas(),
    quanLyThuChiNgoaiLeSagas(),
    nguonVonSagas(),
    banHangTraGopSagas(),
    themMoiBanHangTraGopSagas(),
    CauHinhGoiTraGopSagas(),
    ticketSaga(),
  ]);
}
